import script from "./LoginComponents.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginComponents.vue?vue&type=script&setup=true&lang=js"

import "./LoginComponents.vue?vue&type=style&index=0&id=0f3c2cde&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f3c2cde"]])

export default __exports__